import { mapState } from 'vuex';

export default {
  props: {
    title: String,
    showExport: {
      type: Boolean,
      default: false,
    },
    activeTab: {
      type: String,
      default: null,
    },
  },
  methods: {
    onExport() {
      this.$emit('export', this.activeTab);
    },
  },
  computed: {
    ...mapState('profile', ['transactionHistory', 'tradeHistory']),
    isExportAvailable() {
      const hasItems = (this.activeTab === 'trades')
        ? true
        : (this.transactionHistory && this.transactionHistory.data && this.transactionHistory.data.length > 0);

      return this.showExport && hasItems;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/account-desktop-header/account-desktop-header.js